/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ChatSummaryFromJSON, ChatSummaryToJSON } from './ChatSummary';
import { PageInfoFromJSON, PageInfoToJSON } from './PageInfo';
export function GetChatSummariesResponseDataFromJSON(json) {
    return GetChatSummariesResponseDataFromJSONTyped(json, false);
}
export function GetChatSummariesResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        chatSummaries: !exists(json, 'chat_summaries')
            ? undefined
            : json['chat_summaries'].map(ChatSummaryFromJSON),
        pageInfo: !exists(json, 'page_info') ? undefined : PageInfoFromJSON(json['page_info'])
    };
}
export function GetChatSummariesResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        chat_summaries: value.chatSummaries === undefined ? undefined : value.chatSummaries.map(ChatSummaryToJSON),
        page_info: PageInfoToJSON(value.pageInfo)
    };
}
